module.exports = __webpack_public_path__ + "static/media/duke.67da9897.jpg";